export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/index.6d5d291d.worker.js");
}
